"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("circle", { cx: "12", cy: "12", r: "10", fill: "#E4E7EE" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 6V8.49887H11V6H13ZM10 9.99904H13V18H11V11.9993H10V9.99904Z", fill: "currentColor" })));
